module.exports = __webpack_public_path__ + "img/user.1a3a9910.jpg";